import { Box } from "@drone-js/core";
import { postPublishSuccessBinder } from "libs/analytics/binders/onboarding/postPublishSuccess";
import { useAnalytics } from "libs/analytics/useAnalytics";
import { OneOnboardingSkeleton } from "../Skeleton";
import { useStaticDataAtomValue } from "../staticDataAtom";
import { FinishIncompleteListings } from "./FinishIncompleteListings";
import { WhatsNext } from "./WhatsNext";
import { useGetPropertyViewModel } from "./useGetPropertyViewModel";

export const CompletePage = () => {
    useGetPropertyViewModel();
    useAnalytics(postPublishSuccessBinder);
    const staticData = useStaticDataAtomValue();

    if (staticData === undefined) return <OneOnboardingSkeleton />;

    return (
        <Box id="complete-section" maxWidth="848px" mx="auto">
            <WhatsNext />
            <FinishIncompleteListings />
        </Box>
    );
};
